<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      Liver Specific Details EMR Preview
    </template>
    <template #body>
      <div class="sections">
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="testDate"
              disabled
              label="Test Date"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="serumBilirubin"
              disabled
              label="Serum Bilirubin"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="inr"
              disabled
              label="INR"
            />
          </div>
        </div>
    
        
   
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="serumSodium"
              disabled
              label="Serum Sodium"
            />
          </div> 

          <div class="col-2">
            <ADSTextInput
              v-model="serumCreatinine"
              disabled
              label="Serum Creatinine"
            />
          </div>
         

          <div class="col-2">
            <ADSTextInput
              v-model="serumAlbumin"
              disabled
              label="Serum Albumin"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="recentDialysisAndCreatinineTest"
              disabled
              label="Recent Dialysis and Creatinine Test"
            />
          </div>
        </div>
      </div>
    </template>
  </ADSCardSection>
</template>

<script>
import _ from 'lodash';

export default {
  name: "LiverSpecificSectionDetails",
  props: {
    patient: {
      type: Object,
      default: null,
    },
    patientBundle: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      testDate: this.getTestDate( this.patientBundle ),
      serumCreatinine: this.getSerumCreatinine( this.patientBundle ),
      inr: this.getINR( this.patientBundle ),
      serumSodium: this.getSerumSodium( this.patientBundle ), 
      serumAlbumin: this.getSerumAlbumin( this.patientBundle ), 
      recentDialysisAndCreatinineTest: this.getRecentDialysisAndCreatinineTest( this.patientBundle ),
      serumBilirubin: this.getSerumBilirubin( this.patientBundle ),
    };
    },
   mounted() {
    
    },
  methods: {
    combineProps() {
      return `${this.patient}`;
    },
    getSmartdataComponentValue( patientBundle, observationCode, valuePath = 'valueString' ) {
      const entries = patientBundle?.entries;
      if( !entries?.length ) {
        return null;
      }
      const smartdataGroups = entries.filter( ( n ) =>
        _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata'
      );
      const group = smartdataGroups[0];
      if( !group ) {
        return null;
      }
      const match = group.filter( ( n ) => _.get( n, 'resource.code.coding[0].code' ) === observationCode );
      if( !match[0] ) {
        return null;
      }
      const raw = _.get( match[0], `resource.component[0].${valuePath}` );
      if( raw === null || raw === undefined ) {
        return null;
      }
      return String( raw );
    },
    getTestDate( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#3961', 'valueDateTime' );
    },
    getSerumCreatinine( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#3965' );
    },
    getINR( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#3963', );
    },
    getSerumSodium( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#3964' );
    },
    getSerumAlbumin( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#3966' );
    },
    getRecentDialysisAndCreatinineTest( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#3797' );
    },
    getSerumBilirubin( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#3962' );
    },
  },
};
</script>

<style scoped>

/* .card {
  height: 560px;
} */

.sectionHeading {
  background-color: rgb(59, 53, 53);
  color: white;
  padding-left: 5px;
}

.page-content .summary-card .card-header .summary-name {
  padding-left: 35px;
  padding-top: 4px;
  font-weight: 300;
}

.sections {
  font-size: 15px;
  height: 350px;
  width: 1400px;
  /* overflow: scroll; */
  padding-left: 10px;
  padding-top: 5px;
}

.inputDisplay {
border-style: solid;
background-color: #F2F2F2;
}

.fieldName {
  font-weight: 700;
  font-size: 0.875rem;
  padding-top: 5.5px;
  padding-bottom: 2.5px;
}

:deep(.afflo-ds-form-control) {
  width: max-content;
}

:deep(label) {
  width: max-content;
}

</style>
